// extracted by mini-css-extract-plugin
export default {"story-feed":"StoryFeed_story-feed__tPecw","story-feed__cards":"StoryFeed_story-feed__cards__aSXPf"};